import React, { useState } from "react"
import { CardBody, Container, Row, Col, Card } from "reactstrap"

import { AutoComplete } from "components/AutoComplete"
import { TableTopHeading } from "components/TableTopHeading"
import InventoryRequestIcon from "../../../assets/images/inventory-request/InventoryRequestIcon.png"
import ActionEyeIcon from "../../../assets/images/inventory-request/action-eye-icon.png"
import { Pagination } from "components/Pagination"
import { DataTable } from "components/DataTable"
import { PageLimit } from "components/PageLimit"

import ViewDetailsInventoryRequest from "./ViewDetailsDepartmentRequest"
import { Modal } from "components/Modal"
import { useHistory } from "react-router-dom"
import { GetDepartmentInventoryRequestListing } from "../../../api/api.service"
import { useLocalPaginatedRequest } from "hooks/useLocalPaginatedRequest"
import { dateTimeFormat, convertDateTime } from "../../../utils/dateFormatUtils"
import { InventoryReqStatus } from "constants"
import { Refresh } from "components/Refresh"
import useDepartmentConfig from "hooks/useDepartmentConfig"
import autoCompleteStyles from "components/AutoComplete/autoCompleteStyles"

const COLUMNS = {
    REQUEST_NO: "Request No.",
    DATE_OF_REQUEST: "Requested Date",
    STATION_NAME: "Station Name",
    STATUS: "Status",
    ACTION: "Action",
}

const dataKey = "data"
const totalKey = "total"

const InventoryRequestDepartmentListing = () => {
    const {
        currentDepartmentId,
        departmentIds,
        currentDepartmentName,
        departmentManagerName,
    } = useDepartmentConfig()
    const history = useHistory()
    const [filters, setFilters] = useState(null)
    const [selectedData, setSelectedData] = useState([])
    const [modalToggle, setModalToggle] = useState(false)

    const {
        data,
        isFetching,
        page,
        handlePageClick,
        pageSize,
        onChangePageSize,
        total,
        request,
    } = useLocalPaginatedRequest({
        requestFn: GetDepartmentInventoryRequestListing,
        params: {
            ...(filters?.value && { requestStatus: filters?.value }),
            ...(currentDepartmentId
                ? { departmentId: [currentDepartmentId] }
                : { departmentId: departmentIds }),
        },
        deps: [filters, currentDepartmentId],
        dataKey: dataKey,
        totalKey: totalKey,
    })

    const handleSetDetailsDataAndModal = data => {
        setSelectedData(data)
        setModalToggle(true)
    }

    const handleCloseModal = () => {
        setSelectedData([])
        setModalToggle(false)
    }

    const handleSelectOption = option => {
        setFilters(option)
    }
    return (
        <React.Fragment>
            <div className="gt-business-accounts ">
                <Container fluid>
                    <Row>
                        <Col className="col-12 ">
                            <TableTopHeading
                                title={`Inventory Requests (${
                                    currentDepartmentId
                                        ? currentDepartmentName
                                        : departmentManagerName
                                })`}
                                iconImage={InventoryRequestIcon}
                                iconClass="inventory-req-icon"
                            />

                            <Card className="mb-5">
                                <Refresh
                                    onClick={request}
                                    isDisable={isFetching}
                                />

                                <CardBody className="p-2 p-md-4">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <h5 className="fw-600 mb-0 table-main-heading">
                                            Requests
                                        </h5>
                                        <div className="d-flex align-items-center justify-content-center flex-column flex-md-row ">
                                            <div className="status-search-con">
                                                <span className="status-label mx-2">
                                                    Status :
                                                </span>
                                                <AutoComplete
                                                    value={filters}
                                                    isClearable
                                                    onChange={val =>
                                                        handleSelectOption(val)
                                                    }
                                                    isSearchable={false}
                                                    placeholder="Select status"
                                                    customStyles={
                                                        autoCompleteStyles.STYLE_FOUR
                                                    }
                                                    classNamePrefix="status-header-search"
                                                    options={[
                                                        {
                                                            label: "Open",
                                                            value: "Open",
                                                        },
                                                        {
                                                            label: "In Progress",
                                                            value: "InProgress",
                                                        },
                                                        {
                                                            label: "Completed",
                                                            value: "Completed",
                                                        },
                                                    ]}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <PageLimit
                                        page={page}
                                        total={total}
                                        pageSize={pageSize}
                                        changePageSizeHandler={onChangePageSize}
                                        rowLimit={pageSize}
                                        typoClasses="page-limit-typo"
                                        selectClasses="page-limit-select"
                                    />
                                    <DataTable
                                        data={data}
                                        loading={isFetching}
                                        config={[
                                            {
                                                title: COLUMNS.REQUEST_NO,
                                                render: data => data.id,
                                            },
                                            {
                                                title: COLUMNS.STATION_NAME,
                                                render: data =>
                                                    data.departmentName,
                                            },
                                            {
                                                title: COLUMNS.DATE_OF_REQUEST,
                                                render: data =>
                                                    convertDateTime({
                                                        date: data.createdAt,
                                                        customFormat:
                                                            dateTimeFormat.casitaCustomDateFormat,
                                                        dateOnly: true,
                                                    }),
                                            },
                                            {
                                                title: COLUMNS.STATUS,
                                                render: data => {
                                                    return (
                                                        <div
                                                            className={`inv-req-popup-status ${InventoryReqStatus.getLabelClass(
                                                                data.status
                                                            )}`}
                                                        >
                                                            {InventoryReqStatus.getDisplayTextKey(
                                                                data.status
                                                            )}
                                                        </div>
                                                    )
                                                },
                                            },
                                            {
                                                className: "text-center",
                                                title: COLUMNS.ACTION,
                                                render: data => {
                                                    return (
                                                        <span
                                                            className="text-success pointer"
                                                            onClick={() => {
                                                                handleSetDetailsDataAndModal(
                                                                    data
                                                                )
                                                            }}
                                                        >
                                                            <img
                                                                src={
                                                                    ActionEyeIcon
                                                                }
                                                                className="action-icons-size"
                                                            />
                                                        </span>
                                                    )
                                                },
                                            },
                                        ]}
                                    />
                                    <Pagination
                                        currentPage={page}
                                        totalData={total}
                                        onPageClick={handlePageClick}
                                        rowLimit={pageSize}
                                        onChangePageSize={onChangePageSize}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

            <Modal
                isOpen={modalToggle}
                handleModalToggling={handleCloseModal}
                bodyClassName="p-0"
                customButton={true}
                hideModalHeaderSeparator={true}
                headerClasses="pb-0"
                className="inv-req-popup-viewdetails"
                sizeClasses="10"
            >
                <ViewDetailsInventoryRequest
                    modalCloseHandler={handleCloseModal}
                    data={selectedData}
                />
            </Modal>
        </React.Fragment>
    )
}

export default InventoryRequestDepartmentListing
